import { LoadingButton } from '@mui/lab';
import { Box, Button, Grid } from '@mui/material';
import { useSnackbar } from 'notistack';
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useParams } from 'react-router-dom';
import { GeneralDatePicker } from 'src/components/general';
import { FormProvider, RHFTextField } from 'src/components/hook-form';
import { networkGenerateGiftCode } from 'src/network/subscribe-package/giftcode-generation';
import useFormsModalStore from 'src/store/forms';

const GiftCodeGenerate = () => {
  const { projectId } = useParams();
  const { enqueueSnackbar } = useSnackbar();

  const { modal, closeModal } = useFormsModalStore();

  const subscribePackageDetails = modal?.data;

  const [startDate, setStartDate] = useState(new Date(subscribePackageDetails?.SubscribePackageDateStart));
  const [endDate, setEndDate] = useState(new Date(subscribePackageDetails?.SubscribePackageDateEnd));

  const methods = useForm({
    // resolver: yupResolver(schema), // todo schema
    // defaultValues,
  });

  const {
    handleSubmit,
    formState: { isSubmitting },
  } = methods;

  const onSubmit = async (values, event) => {
    if (startDate != 'Invalid Date' || endDate != 'Invalid Date') {
      const PAYLOAD = {
        ...values,
        CreateDate: new Date(startDate).toISOString(),
        ExpireDate: new Date(endDate).toISOString(),
        Count: +values?.Count,
        AppID: +projectId,
        SubscribePackageID: subscribePackageDetails,
      };

      try {
        const res = await networkGenerateGiftCode(PAYLOAD);
        enqueueSnackbar(res?.data?.items?.Desc, { variant: res.data?.items?.ResultID == 1 ? 'success' : 'warning' });
        closeModal();
      } catch (error) {
        console.error(error);
      }
    }
  };

  return (
    <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
      <h2 className="mb-7 font-bold">ایجاد کد</h2>
      <Grid>
        <Box
          sx={{
            display: 'grid',
            columnGap: 3,
            rowGap: 3,
            gridTemplateColumns: { xs: 'repeat(1, 1fr)', sm: 'repeat(2, 1fr)' },
          }}
        >
          <RHFTextField required name="Label" type="text" label="عنوان کد" />

          <RHFTextField required name="Count" type="number" label="تعداد" />

          <GeneralDatePicker
            minDate={new Date()}
            label="تاریخ شروع اعتبار"
            name="CreateDate"
            value={startDate}
            onChangeValue={setStartDate}
          />

          <GeneralDatePicker minDate={startDate} label="تاریخ پایان اعتبار" name="ExpireDate" value={endDate} onChangeValue={setEndDate} />
        </Box>
      </Grid>

      <div className="flex items-center gap-4 mt-64">
        <LoadingButton type="submit" variant="contained" name="save" loading={isSubmitting}>
          ایجاد
        </LoadingButton>
        <Button onClick={closeModal} variant="contained" color="error">
          انصراف
        </Button>
      </div>
    </FormProvider>
  );
};

export default GiftCodeGenerate;
